import * as React from "react";

function Mail(props) {
  return (
    <svg width={22} height={19} fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 .014H3c-1.7 0-3 1.3-3 3v12c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3v-12c0-1.7-1.3-3-3-3zm-16 2h16c.4 0 .7.2.9.6l-8.9 6.2-8.9-6.2c.2-.4.5-.6.9-.6zm-1 13c0 .6.4 1 1 1h16c.6 0 1-.4 1-1v-10.1l-8.4 5.9c-.2.1-.4.2-.6.2-.2 0-.4-.1-.6-.2L2 4.914v10.1z"
        stroke="none"
        fill="currentColor"
      />
    </svg>
  );
}

const MailIcon = React.memo(Mail);
export default MailIcon;
